import Characteristics from '../../../Characteristics';
import { Header } from '../../styles';
import { ContentWrapper, StyledSection } from './styles';

const CharacteristicsComponent = ({ characteristics }) => {
  return (
    <StyledSection>
      <Header>Characteristics:</Header>
      <ContentWrapper>
        <Characteristics characteristics={characteristics} />
      </ContentWrapper>
    </StyledSection>
  );
};

export default CharacteristicsComponent;
